

export const STICKIES_PER_PAGE = 30;
